import { render, staticRenderFns } from "./DiagExtraView.vue?vue&type=template&id=20d09ecc&"
import script from "./DiagExtraView.vue?vue&type=script&lang=js&"
export * from "./DiagExtraView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports